import React from "react";

const BriefPlanning = ({ pfrFormData, setPfrFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPfrFormData("briefPlanning", {
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Brief Planning</h3>
        <div className="form-group">
          <label className="required">Planning Concept</label>
          <textarea
            type="text"
            name="planningConcept"
            value={pfrFormData.briefPlanning.planningConcept}
            onChange={handleInputChange}
            placeholder="Enter Planning Concept"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Population Projection</label>
          <textarea
            type="text"
            name="populationProjection"
            value={pfrFormData.briefPlanning.populationProjection}
            onChange={handleInputChange}
            placeholder="Enter Population Projection"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Land use planning</label>
          <textarea
            type="text"
            name="landUsePlanning"
            value={pfrFormData.briefPlanning.landUsePlanning}
            onChange={handleInputChange}
            placeholder="Enter Land use planning"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">
            Assessment of infrastructure Demand (Physical & Social)
          </label>
          <textarea
            type="text"
            name="assessmentOfInfrastructureDemand"
            value={pfrFormData.briefPlanning.assessmentOfInfrastructureDemand}
            onChange={handleInputChange}
            placeholder="Enter Assessment of infrastructure Demand (Physical & Social)"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Amenities & Facilities</label>
          <textarea
            type="text"
            name="amenitiesAndFacilities"
            value={pfrFormData.briefPlanning.amenitiesAndFacilities}
            onChange={handleInputChange}
            placeholder="Enter Amenities & Facilities"
            required
          />
        </div>
      </div>
    </>
  );
};

export default BriefPlanning;
